import { Component, HostListener, Injector, OnDestroy, OnInit } from '@angular/core';
import { MenuService } from '../core/services/menu.service';
import { BaseComponent } from './../shared/components/base.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SessionServiceService } from '../core/services/session-service.service';
import { AuthenticationService } from '../core/services/authentication-service.service';

@Component({
  selector: 'laas-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  providers: [MenuService]
})
export class LayoutComponent extends BaseComponent implements OnInit {

  isShowLoader: boolean;
  isRwd: boolean;

  constructor(
    injector: Injector,
    public menuDataService: MenuService,
    private breakpointObserver: BreakpointObserver,
    private sessionService: SessionServiceService,
    public readonly authenticationService: AuthenticationService,
  ) {
    super(injector);
    this.isShowLoader = false;
    this.isRwd = false;
  }

  ngOnInit(): void {
    // 添加這段代碼來監聽螢幕寬度變化
    this.breakpointObserver.observe([
      Breakpoints.XSmall
    ]).subscribe(result => {
      this.isRwd = result.matches;
      this.menuDataService.isRwd.next(this.isRwd);
    });

    this.sessionService.updatePermissionCodes();
  }
}
